import React, { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./custom-toast.css"

// Création du contexte
const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  // Fonction pour afficher une notification
  const showToast = (message, type = "info", btnOption = {callback : ()=>{}, text : 'Oopps'}, options = {}) => {

    const { autoClose = 5000, position = "top-right", ...restOptions } = options || {};

    if(type == 'btn'){

      toast((closeToast, data, toastProps,)=>(
              <div className="flex flex-col w-full">
                
                <div className="flex items-center justify-between">
                  <p className="text-sm">{message}</p>
                  <button
                    onClick={btnOption.callback}
                    className="ml-auto transition-all text-xs  border rounded-md px-4 py-2 text-white active:scale-[.95] bg-zinc-900"
                  >
                    {btnOption.text}
                  </button>
                </div>
              </div>
            ),
            {
              position,
              autoClose,
              hideProgressBar: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
              className: "custom-toast", // Classe personnalisée gérée par le context
              ...restOptions,  
            }
      );

    }else{

      toast(message, {
        type,
        position,
        autoClose,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        className: "custom-toast", // Classe personnalisée gérée par le context
        ...restOptions,
      });
    }
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

// Hook personnalisé pour accéder au ToastContext
export const useToast = () => useContext(ToastContext);